<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>

<div class="form-group">
    <label class="label me-2" *ngFor="let item of items">
        <input #field class="form-control" class="me-1" type="radio" [name]="name" [value]="item.id"
            [disabled]="detailMode || readOnly" required (click)="selecionar(item)"
            [checked]="itemSelecionado && itemSelecionado.id == item.id" selected>
        <span>{{ item.nome }}</span>
    </label>
</div>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>